import React, { useState } from 'react';
import { Button } from '../Button';
import BuyNowLiteDialog from './BuyNowLiteDialog';
import styles from './BuyNowLite-tw-styles';
import { useBinLite } from '@procter-gamble/bin-lite-button'

const BuyNowLite = (props) => {
  
  // Bail out on server-side rendering
  if (typeof window === 'undefined') {
    return null;
  }
  
    const [ open,setOpen] = useState(false)
    const { gtinId } = props;
    const linkText = 'COMPRAR';
    const binParams = {
      gtin: gtinId,
      passkey: process.env.BUYNOW_LITE_PASSKEY,
      orderby: 'random',
      retailersChoice: 'desired',
      isDevelopment: process.env.PROJECT_ENV.trim() === 'development'
  }
  
  const { retailers, fetchRetailers } = useBinLite(binParams);

  const handleDialogViewState = () => {

    setOpen(!open)
    if(!open){
      fetchRetailers();
    }
  };

  const closeDialog = () => {
    this.setState({ open: false });
  };

   const { className, detachBNL, variant, productShortName, ratingData, ratingCount, overallRatingRange } = props;
    
    // Create accessible name with product name and rating
    let ariaLabel = `Comprar ${productShortName || ''}`;
    
    // Always add rating info, use 0 as default for null/undefined/0 values
    const rating = (typeof ratingData === 'number' && ratingData > 0) ? ratingData : 0;
    const count = (typeof ratingCount === 'number' && ratingCount > 0) ? ratingCount : 0;
    const formattedRating = rating % 1 === 0 ? rating : rating.toFixed(2);
    
    ariaLabel += `, ${formattedRating} de ${overallRatingRange || 5} estrellas, ${count} ${count === 1 ? 'avaliação' : 'avaliações'}`;
    
    return (
      <div>
        <Button
          className={className}
          data-action-detail={gtinId}
          onClick={handleDialogViewState}
          aria-label={ariaLabel}
        >
           {linkText}
        </Button>
        {!detachBNL ? (
          <BuyNowLiteDialog
            open={open}
            onCloseHandler={handleDialogViewState}
            buyNowData={retailers}
            variant={variant}
            productShortName={productShortName}
          />
        ) : (
          ''
        )}
      </div>
    );
}

export default BuyNowLite;